import { useState } from "react";
import { toast } from "sonner";
import { Copy, Smartphone, MessageCircle } from "lucide-react";
import { useAuth } from "../../lib/auth";
import { SITE } from "../../lib/site";

export default function ManualPay({ price }) {
  const { user } = useAuth();
  const [copied, setCopied] = useState(false);
  const upiLink = `upi://pay?pa=${SITE.upiId}&pn=99Bazaar%20Maharashtra&am=${price}&cu=INR&tn=Membership`;
  const msg = encodeURIComponent(`नमस्कार, मी 99Bazaar Membership ₹${price} PhonePe/GooglePay ने भरले आहे.\nनाव: ${user?.name || ""}\nमोबाईल: ${user?.mobile || ""}\n(Payment screenshot जोडत आहे)`);
  const copy = async () => {
    try { await navigator.clipboard.writeText(SITE.upiId); setCopied(true); toast.success("UPI ID copied"); }
    catch { toast.error(`Copy झाले नाही - UPI ID: ${SITE.upiId}`); }
  };
  return (
    <div className="rounded-2xl bg-white border-2 border-[var(--buy)] p-6 flex flex-col" data-testid="manual-pay-box">
      <p className="font-display font-bold text-xl text-[var(--navy)] flex items-center gap-2"><Smartphone className="w-5 h-5 text-[var(--buy)]" /> PhonePe / Google Pay ने भरा</p>
      <ol className="mt-4 space-y-3 text-sm text-slate-700 list-decimal pl-5">
        <li>खालील UPI ID वर <b>₹{price}</b> भरा:
          <div className="mt-2 flex items-center gap-2">
            <code className="flex-1 px-3 py-2 rounded-lg bg-slate-100 font-semibold text-[var(--navy)]" data-testid="manual-pay-upi-id">{SITE.upiId}</code>
            <button onClick={copy} className="h-9 px-3 rounded-lg border border-slate-300 text-xs font-semibold flex items-center gap-1" data-testid="manual-pay-copy-button"><Copy className="w-3.5 h-3.5" /> {copied ? "Copied" : "Copy"}</button>
          </div>
        </li>
        <li>Payment चा screenshot आणि तुमचा नोंदणीकृत मोबाईल नंबर WhatsApp करा.</li>
        <li>आम्ही तपासून काही वेळातच तुमचा 1 वर्षाचा प्लॅन सुरू करू.</li>
      </ol>
      <div className="mt-5 grid grid-cols-2 gap-3">
        <a href={upiLink} className="h-11 rounded-xl bg-[#5f259f] hover:bg-[#4d1e82] text-white text-sm font-semibold flex items-center justify-center md:hidden" data-testid="manual-pay-upi-link">UPI App उघडा</a>
        <a href={`https://wa.me/${SITE.whatsapp}?text=${msg}`} target="_blank" rel="noopener noreferrer" className="h-11 col-span-2 md:col-span-2 rounded-xl bg-[#25D366] hover:bg-[#1ebe5a] text-white text-sm font-semibold flex items-center justify-center gap-2" data-testid="manual-pay-whatsapp">
          <MessageCircle className="w-4 h-4" /> Screenshot WhatsApp करा
        </a>
      </div>
      <p className="mt-3 text-xs text-slate-500">Online Card/UPI Payment (Razorpay) - लवकरच सुरू</p>
    </div>
  );
}
